import * as React from 'react';
import { container as style } from './style';
export const [OPEN_WIDTH, COLLAPSED_WIDTH] = [250, 60];
const ctx = React.createContext({
    width: OPEN_WIDTH,
    updateWidth: (__width) => ({}),
    toggle: () => ({}),
});
export const SidePanelContext = ctx;
export const Container = (props) => {
    const [width, updateWidth] = React.useState(COLLAPSED_WIDTH);
    const toggle = () => {
        updateWidth(width > COLLAPSED_WIDTH ? COLLAPSED_WIDTH : OPEN_WIDTH);
    };
    return (React.createElement(SidePanelContext.Provider, { value: { width, updateWidth, toggle } },
        React.createElement("div", { className: style }, props.children)));
};
Container.defaultProps = {
    sidePanelWidth: COLLAPSED_WIDTH,
};
//# sourceMappingURL=Container.js.map